import { HttpClient, HttpParams } from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {map} from 'rxjs/internal/operators';
import {environment} from '../../../environments/environment';
import {ActivationEntry} from './activation-entry.object';

@Injectable()
export class ActivationEntryService {

  defaultInclude = ['AccountActivation'];

  constructor(private http: HttpClient) {
  }

  get(ReqParams: HttpParams = null): Observable<ActivationEntry[]> {
    return this.http
        .get<ActivationEntry[]>(environment.apiUrl + '/ActivationEntries', {params: ReqParams})
        .pipe(
            map(res => <ActivationEntry[]>res),
            map(res => {
              return res.map(rel => new ActivationEntry(rel));
            })
        );
  }

  upsert(input: ActivationEntry): Observable<ActivationEntry> {
    return this.http
        .put<ActivationEntry>(environment.apiUrl + '/ActivationEntries', JSON.stringify(input))
        .pipe(
            map(res => <ActivationEntry>res),
            map(res => {
              // Modify original doc without destroying related nexted objects
              for (const prop in res) if (prop in input) input[prop] = res[prop];
              return new ActivationEntry(input);
            })
        );
  }

  upsertAll(input: ActivationEntry[]): Observable<ActivationEntry[]> {
    return this.http
        .put<ActivationEntry[]>(environment.apiUrl + '/ActivationEntries/replaceOrCreateAll', JSON.stringify(input))
        .pipe(
            map(res => <ActivationEntry[]>res),
            map(res => {
              // Modify original doc without destroying related nexted objects
              for (const prop in res) {
                if (prop in input) {
                  Object.assign(input[prop], res[prop]);
                }
              }
              return input;
            })
        );
  }

  remove(input: ActivationEntry): Observable<{ count: number }> {
    return this.http
        .delete<{ count: number }>(environment.apiUrl + '/ActivationEntries/' + input.Id);
  }

  count(ReqParams: HttpParams = null): Observable<{ count: number }> {
    return this.http
        .get(environment.apiUrl + '/ActivationEntries/count', {params: ReqParams})
        .pipe(
            map(res => <{ count: number }>res)
        );
  }
}
